// extracted by mini-css-extract-plugin
export var compactFilters = "_cw-4";
export var detailImage = "_cw-1";
export var dropdownContainer = "_cw-2";
export var imageContainer = "_cw-0";
export var selectedCard = "_cw-3";